import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'
import { RESET_PASSWORD } from '@/services/endpoints'

import { useErrorHandler } from './useErrorHandler'

export const useResetPassword = ({ token, config = {} }) => {
  const api = useLegacyPublicApi()

  const [error, setError] = useState(null)
  const resolvedError = useErrorHandler(error)

  const {
    mutateAsync: mutate,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: async (data) => {
      if (!token || !data.newPassword) return false

      const payload = {
        token,
        password: data.newPassword,
      }

      return await api.post(RESET_PASSWORD, payload)
    },
    onSuccess: () => {
      setError(null)
    },
    onError: (error) => {
      setError(error)
    },
    ...config,
  })

  const resetPassword = (data) => mutate(data)

  return {
    resetPassword,
    isLoading,
    isSuccess,
    error: resolvedError,
  }
}
